import { ArrowRight } from "lucide-react";

export default function Newsletter() {
    
  return (
    <section className="bg-[#F7F8F4] py-32">

      <div className="mx-auto max-w-7xl px-6">

        <div className="overflow-hidden rounded-[40px] bg-white shadow-sm">

          <div className="grid lg:grid-cols-2">

            {/* Left Side */}

            <div className="p-10 md:p-16 lg:p-20">

              <span className="uppercase tracking-[4px] text-[#6B8E5F] text-sm">
                Stay Inspired
              </span>

              <h2 className="mt-6 text-4xl font-semibold leading-tight md:text-6xl">
                Join Our
                <br />
                Community.
              </h2>

              <p className="mt-8 max-w-lg text-lg leading-8 text-gray-600">
                Receive thoughtful stories, seasonal collections,
                coffee releases, reading recommendations, and
                inspiration for intentional living.
              </p>

              {/* Form */}

              <form className="mt-10">

                <div className="flex flex-col gap-4 sm:flex-row">

                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="
                    flex-1
                    rounded-full
                    border
                    border-gray-200
                    px-6
                    py-4
                    outline-none
                    focus:border-[#6B8E5F]
                    "
                  />

                  <button
                    className="
                    flex
                    items-center
                    justify-center
                    gap-2
                    rounded-full
                    bg-[#6B8E5F]
                    px-8
                    py-4
                    text-white
                    transition
                    hover:bg-[#557149]
                    "
                  >
                    Subscribe

                    <ArrowRight size={18} />

                  </button>

                </div>

              </form>

              <p className="mt-5 text-sm text-gray-500">
                No spam. Unsubscribe anytime.
              </p>

            </div>

            {/* Right Side */}

            <div className="relative min-h-[450px]">

              <img
                src="/images/newsletter.jpg"
                alt="Newsletter"
                className="absolute inset-0 h-full w-full object-cover"
              />

              <div className="absolute inset-0 bg-black/20" />

              {/* Floating Quote */}

              <div className="absolute bottom-8 left-8 right-8 rounded-3xl bg-white/95 p-8 backdrop-blur">

                <p className="text-lg italic leading-8 text-gray-700">
                  "The little rituals we practice every day shape
                  the quality of our lives."
                </p>

                <div className="mt-4 text-sm uppercase tracking-wider text-[#6B8E5F]">
                  Cultivate Journal
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
}